export const en = {
    'launcher.open': 'Open chat',
    'launcher.close': 'Close chat',
    'launcher.prompt': 'Ask me',
    'header.title': 'Website assistant',
    'header.aiNotice': 'You are chatting with an automated assistant (AI).',
    'header.privacyLink': 'Privacy notice',
    'header.contactLink': 'Contact',
    'header.languageSelector': 'Language',
    'header.available': 'Answers instantly',
    'language.el': 'Ελληνικά',
    'language.en': 'English',
    'language.fr': 'Français',
    'language.auto': 'Automatic',
    'composer.placeholder': 'Type your question…',
    'composer.send': 'Send',
    'composer.sending': 'Sending…',
    'conversation.newConversation': 'New conversation',
    'conversation.starterQuestions': 'Frequently asked questions',
    'conversation.feedbackHelpful': 'Helpful answer',
    'conversation.feedbackNotHelpful': 'Not helpful',
    'conversation.feedbackThanks': 'Thank you for the feedback.',
    'conversation.noEvidence': 'I do not have an answer from this site’s approved information yet.',
    'conversation.sources': 'Sources',
    'conversation.aiAgent': 'AI Agent',
    'status.connecting': 'Connecting…',
    'status.reconnecting': 'The connection dropped. Waiting for it to return…',
    'status.notConnected': 'The assistant is not connected to the platform yet.',
    'error.offline': 'The service is currently unavailable. Please try again later.',
    'error.offline.retry': 'Retry connection',
    'error.timeout': 'The answer took too long. Please try again.',
    'error.quotaExceeded': 'The answer limit has been reached. Please contact us for help.',
    'error.rateLimited': 'Too many requests in a short time. Please wait a moment and try again.',
    'error.unsupportedLanguage': 'I can answer in Greek, English or French. Please choose a language.',
    'error.generic': 'Something went wrong. Please try again.',
    'conversation.sourcesHint': 'From this site’s approved pages.',
    'header.aiNoticeStrong': 'You are chatting with AI — answers use only approved site content.',
    'contact.open': 'Contact',
    'contact.close': 'Close form',
    'contact.title': 'Contact form',
    'contact.required': 'Fill in the required fields.',
    'contact.name': 'Name',
    'contact.email': 'Email',
    'contact.phone': 'Phone (optional)',
    'contact.message': 'Message',
    'contact.quoteMessage': 'I would like to request a quote.',
    'contact.notice': 'Your details are used only to contact you about your request.',
    'contact.marketingOptIn': 'I would like to receive updates (optional)',
    'contact.submit': 'Submit',
    'contact.success': 'Your request has been recorded. We will be in touch soon.',
};
//# sourceMappingURL=en.js.map